import React from 'react';
import { useMap } from 'react-leaflet';

/**
 * Botón "mi ubicación" + zoom +/- flotantes sobre el mapa (README 5.1).
 * Debe renderizarse DENTRO de un <MapContainer> de react-leaflet: usa
 * `useMap()` para controlar la instancia real de Leaflet.
 */
const MapFloatingControls = ({ onLocate, locating }) => {
  const map = useMap();

  return (
    <div className="mp-map-controls">
      <button
        type="button"
        className="mp-control-btn"
        onClick={onLocate}
        disabled={locating}
        title="Mi ubicación actual"
      >
        <i className={`fas ${locating ? 'fa-spinner fa-spin' : 'fa-crosshairs'}`}></i>
      </button>
      <div className="mp-zoom-group">
        <button type="button" onClick={() => map.zoomIn()} title="Acercar">+</button>
        <button type="button" onClick={() => map.zoomOut()} title="Alejar">−</button>
      </div>
    </div>
  );
};

export default MapFloatingControls;
